export const addButtonSx = {
  backgroundColor: "#F2F4F8",
  border: "none",
  height: 44,
  width: 44,
};

export const removeButtonSx = {
  backgroundColor: "#F4363633",
  border: "none",
  height: 44,
  width: 44,
};

type DataType = {
  cyrela: {
    id: number;
    nome: string;
    idCorretor: string;
    tipoDocumento: string;
    documento: string;
    corretorParceiro: boolean;
  }[];
  cliente: { id: number; nome: string }[];
  locais: { id: number; torre: string; idTorre: string; unidade: string }[];
  veiculos: { id: number; veiculo: string; placa: string }[];
};

export const solicitacaoDataTemplate: {
  [K in keyof DataType]: () => DataType[K][number];
} = {
  cyrela: () => ({
    id: Date.now(),
    nome: "",
    idCorretor: "",
    tipoDocumento: "",
    documento: "",
    corretorParceiro: false,
  }),
  cliente: () => ({ id: Date.now(), nome: "" }),
  locais: () => ({ id: Date.now(), torre: "", idTorre: "", unidade: "" }),
  veiculos: () => ({ id: Date.now(), veiculo: "", placa: "" }),
};

export interface SolicitacaoData {
  idEmpreendimento: string;
  localizacaoChave: number | null;
  cyrela: {
    id: number;
    nome: string;
    idCorretor: string;
    tipoDocumento: number | null;
    documento: string;
    corretorParceiro: boolean;
  }[];
  cliente: { id: number; nome: string }[];
  locais: { id: number; torre: string; idTorre: string; unidade: string }[];
  veiculos: { id: number; veiculo: string; placa: string }[];
  dataAgendamento: Date | null;
  horaInicioAgendamento: Date | null;
  horaFimAgendamento: Date | null;
}

export const defaultSolicitacaoData = {
  idEmpreendimento: "",
  localizacaoChave: null,
  cyrela: [
    {
      id: Date.now(),
      nome: "",
      idCorretor: "",
      tipoDocumento: null,
      documento: "",
      corretorParceiro: false,
    },
  ],
  cliente: [{ id: Date.now(), nome: "" }],
  locais: [{ id: Date.now(), torre: "", idTorre: "", unidade: "" }],
  veiculos: [{ id: Date.now(), veiculo: "", placa: "" }],
  dataAgendamento: null,
  horaInicioAgendamento: null,
  horaFimAgendamento: null,
};

export enum TDocVisita {
  CPF = 0,
  CRECI = 1,
  RG = 2,
}

export const TipoDocumentoOptions = [
  {
    label: "CPF (XXX.XXX.XXX-XX)",
    value: 0,
  },
  {
    label: "CRECI (XXXXX)",
    value: 1,
  },
  {
    label: "RG (XX.XXX.XXX-X)",
    value: 2,
  },
];

export enum LocChaveVisita {
  "App Chavi" = 1,
  "Plantão" = 2,
  "Secretaria" = 3,
}

export enum DiasSemanaVisita {
  "Domingo" = 0,
  "Segunda" = 1,
  "Terça" = 2,
  "Quarta" = 3,
  "Quinta" = 4,
  "Sexta" = 5,
  "Sábado" = 6,
}
